// Config for marketing consent toggle on sign up
export const marketingConsentActivated = true;
// Brand privacy url to be added
export const brandPrivacyPolicyUrl =
  'https://www.replayjeans.com/privacy/?srsltid=AfmBOooZVpV2fRpHrVtZpG9Ta6VtvYlkaIOWTjm9w8HDbzVx45tPSPKE';
